import React from "react";

export interface IStorageManagerDriver<TData = any> {
  setStorage: (key: string, data: TData) => void;
  getStorage: (key: string) => TData;
  deleteStorage: (key: string) => void;
}

export const StorageManagerDefaultData: IStorageManagerDriver = {
  setStorage: (key, data) => void 0,
  getStorage: (key) => undefined,
  deleteStorage: (key) => void 0,
};

export const StorageManagerDriver = <TMoreContext,>(moreContext?: TMoreContext): React.Context<IStorageManagerDriver & TMoreContext> =>
  React.createContext<IStorageManagerDriver & TMoreContext>({
    ...StorageManagerDefaultData,
    ...moreContext,
  } as IStorageManagerDriver & TMoreContext);
